module.exports = __webpack_public_path__ + "static/media/my.24b22972.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/my.png
// module id = 1936
// module chunks = 0